<template>
  <ContentCardSubheader :back-to="{ name: ReviewsRouteName.ReviewsAgencyReviewsView, params: { agencyId: route.params.agencyId } }">
    <span class="pr-2">
      {{
        t('Reviews.agency.reviews.reviewDetailTitle', {
          authorName: review.reviewerName || t('Reviews.agency.reviews.table.unknownAuthor'),
        })
      }}
    </span>
    <UniversalReviewStatusBadge class="flex" :review="review" />
    <ReviewInteractionStatus v-if="hasReply" subject="agency" :type="ReviewInteractionType.REPLY_CHECK" class="ml-2" />
    <template #actions>
      <button v-if="canAddReply" class="btn-primary-color-s" data-testid="reviews-send-reply" @click="$emit('send-reply')">
        {{ t('Reviews.agency.view.actions.sendReply') }}
      </button>
    </template>
  </ContentCardSubheader>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import type { UniversalReviewDetail } from '@/components/ReviewsAgenciesManagements/Reviews/types'
import UniversalReviewStatusBadge from '@/components/ReviewsAgenciesManagements/Reviews/UniversalReviewStatusBadge.vue'
import ReviewInteractionStatus from '@/components/ReviewsCommon/ReviewInteractionStatus/ReviewInteractionStatus.vue'
import { ReviewInteractionType } from '@/components/ReviewsCommon/ReviewInteractionStatus/types'
import { UniversalReviewStates } from '@/gql/reviews'
import { ReviewsRouteName } from '@/router/types'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

const props = defineProps<{ review: UniversalReviewDetail }>()

defineEmits(['send-reply'])

const { t } = useI18n()
const route = useRoute()

const hasReply = computed(() => !!props.review.reviewReply)
const canAddReply = computed(() => props.review.currentStatus === UniversalReviewStates.Published && !hasReply.value)
</script>
